import React, { useEffect, useState } from "react";
import DropdownButton from "./DropdownButton";
import ActionButton from "./ActionButton";
import SingleDropdown from "./SingleDropdown";
import { conditionsOperatorObject } from "Static/constant";
import contactStoreData from "Stores/contactData";
import Utils from "Utils/utils";

const ContactSequenceFilter = props => {
  const {
    label = "",
    keyValue = "",
    activeFilter = "",
    errMsg = "",
    data = [],
    sequenceLoader = false,
    sequenceList = [],
    setActiveFilter = () => {},
    setAction = () => {},
    selectedFilterCbk = () => {},
    handleScrollEnd = () => {},
    setErrMsg = () => {},
    filterFn = () => {}
  } = props || {};

  let toggleDropdown = activeFilter === keyValue;

  const [activeDropdownIndex, setActiveDropdownIndex] = useState(false);

  const validateFieldNameAlreadyExist = (newFieldName = "") => {
    let count = 0;
    if (data?.length > 1) {
      data.some(element => {
        if (element?.fieldName === newFieldName) {
          count++;
        }
      });
    }
    return !count > 0;
  };

  const handleAction = (refId = "", item = "", index = "") => {
    if (refId === "fieldName") {
      if (!validateFieldNameAlreadyExist(item?.subKey)) {
        return;
      }
      errMsg && setErrMsg();
      const newFieldName = item?.subKey || "";
      const prevFieldName = data?.[index]?.fieldName || "";
      if (!prevFieldName) {
        let tempAddData = [...data];
        tempAddData[index].fieldName = newFieldName;
        tempAddData[index].sequenceId = "";
        tempAddData[index].sequenceName = "";
        setActiveDropdownIndex(false);
        setAction(keyValue, tempAddData);
        selectedFilterCbk("add", keyValue);
        return;
      }

      if (prevFieldName === newFieldName) {
        setActiveDropdownIndex(false);
        return;
      }

      let rowsToRemove = new Set([index]);
      const currentRowIsMultiple = data[index]?.isMultiple === true;

      if (currentRowIsMultiple) {
        const parentIdx = data.findIndex(
          (itm, idx) =>
            idx < index && itm?.fieldName === prevFieldName && !itm?.isMultiple
        );

        if (parentIdx !== -1) {
          rowsToRemove.add(parentIdx);
          data.forEach((itm, idx) => {
            if (
              idx !== parentIdx &&
              idx !== index &&
              itm?.fieldName === prevFieldName &&
              itm?.isMultiple
            ) {
              rowsToRemove.add(idx);
            }
          });
        } else {
          data.forEach((itm, idx) => {
            if (
              idx > index &&
              itm?.fieldName === prevFieldName &&
              itm?.isMultiple
            ) {
              rowsToRemove.add(idx);
            }
          });
        }
      } else {
        data.forEach((itm, idx) => {
          if (
            idx !== index &&
            itm?.fieldName === prevFieldName &&
            itm?.isMultiple
          ) {
            rowsToRemove.add(idx);
          }
        });
      }
      const sortedIndicesToRemove = Array.from(rowsToRemove).sort(
        (a, b) => a - b
      );
      let filtered = [...data];
      for (let i = sortedIndicesToRemove.length - 1; i >= 0; i--) {
        filtered.splice(sortedIndicesToRemove[i], 1);
      }

      let insertionIdx = index;
      for (const removeIdx of sortedIndicesToRemove) {
        if (removeIdx < index) {
          insertionIdx--;
        }
      }

      const freshItem = {
        fieldName: newFieldName,
        sequenceId: "",
        sequenceName: "",
        isMultiple: false
      };

      insertionIdx = Math.max(0, Math.min(insertionIdx, filtered.length));
      const nextData = [
        ...filtered.slice(0, insertionIdx),
        freshItem,
        ...filtered.slice(insertionIdx)
      ];
      setActiveDropdownIndex(false);
      setAction(keyValue, nextData);
      selectedFilterCbk("add", keyValue);
      return;
    }
    errMsg && setErrMsg();
    let tempData = [...data];
    tempData[index][refId] = item?.subKey || "";
    setActiveDropdownIndex(false);
    setAction(keyValue, tempData);
  };
  const validateSeqAlreadyExist = (id = "") => {
    let count = 0;
    if (data?.length > 1) {
      data.some(ele => {
        if (ele?.sequenceId === id) {
          count++;
        }
      });
    }
    return count > 0;
  };

  const handleSequenceAction = (index = "", item = {}) => {
    errMsg && setErrMsg();
    let tempData = [...data];
    if (validateSeqAlreadyExist(item?.id)) {
      return;
    }
    tempData[index]["sequenceId"] = item?.id || "";
    tempData[index]["sequenceName"] = item?.name || "";
    setActiveDropdownIndex(false);
    setAction(keyValue, tempData);
    errMsg && setErrMsg("");
  };

  const resetOrAddNewItem = (isPush = false) => {
    let newObj = {
      fieldName: "",
      sequenceId: "",
      sequenceName: "",
      isMultiple: false
    };
    if (isPush) {
      return newObj;
    }
    errMsg && setErrMsg();
    selectedFilterCbk("remove", keyValue);
    setAction(keyValue, [newObj]);
  };

  const resetOrAddNewItemV2 = ({
    isPush = false,
    isMultiple = false,
    fieldName = ""
  } = {}) => {
    let newObj = {
      fieldName: fieldName,
      sequenceId: "",
      sequenceName: "",
      isMultiple: isMultiple
    };
    if (isPush && isMultiple) {
      return newObj;
    }
    if (isPush) {
      return newObj;
    }
    errMsg && setErrMsg();
    selectedFilterCbk("remove", keyValue);
    setAction(keyValue, [newObj]);
  };

  const removeItem = index => {
    let tempData = [...data];
    const fieldNameToRemove = tempData[index]?.fieldName || "";
    if (fieldNameToRemove) {
      const indicesToRemove = new Set([index]);
      tempData.forEach((item, idx) => {
        if (
          idx !== index &&
          item?.fieldName === fieldNameToRemove &&
          item?.isMultiple
        ) {
          indicesToRemove.add(idx);
        }
      });
      const sortedIndices = Array.from(indicesToRemove).sort((a, b) => b - a);
      sortedIndices.forEach(idx => {
        tempData.splice(idx, 1);
      });
    } else {
      tempData.splice(index, 1);
    }
    let len = tempData?.length;
    if (len === 1) {
      resetOrAddNewItem();
    } else {
      tempData.filter(item => item?.fieldName)?.length < 1 &&
        selectedFilterCbk("remove", keyValue);
      setAction(keyValue, tempData);
    }
    errMsg && setErrMsg();
  };

  const removeSelectedSeqItem = index => {
    let tempData = [...data];
    const rowToDelete = tempData[index];
    const fieldName = rowToDelete?.fieldName || "";
    const isRowMultiple = rowToDelete?.isMultiple === true;
    let len = tempData?.length;
    if (len === 1) {
      resetOrAddNewItemV2();
    } else {
      if (fieldName && !isRowMultiple) {
        const firstChildIdx = tempData.findIndex(
          (itm, idx) =>
            idx !== index &&
            itm?.fieldName === fieldName &&
            itm?.isMultiple === true
        );
        if (firstChildIdx !== -1) {
          tempData[firstChildIdx].isMultiple = false;
        }
      }
      tempData.splice(index, 1);
      tempData.filter(item => item?.fieldName)?.length < 1 &&
        selectedFilterCbk("remove", keyValue);
      setAction(keyValue, tempData);
    }
    errMsg && setErrMsg();
  };

  const addMultipleSequences = (fieldName = "") => {
    errMsg && setErrMsg();
    let tempData = [...data];
    tempData.push(
      resetOrAddNewItemV2({
        isPush: true,
        isMultiple: true,
        fieldName: fieldName
      })
    );
    setAction(keyValue, tempData);
  };

  const addItem = () => {
    errMsg && setErrMsg();
    let tempData = [...data];
    tempData.push(resetOrAddNewItem(true));
    setAction(keyValue, tempData);
  };

  const resetItem = () => {
    errMsg && setErrMsg();
    data?.filter(item => item?.fieldName)?.length && resetOrAddNewItem();
  };

  const optionList = [
    {
      value: "Active in sequence",
      subKey: "ACTIVE_IN_SEQUENCE",
      key: "activeInASequence",
      method: handleAction
    },
    {
      value: "Completed in sequence",
      subKey: "COMPLETED_IN_SEQUENCE",
      key: "completedInASequence",
      method: handleAction
    },
    {
      value: "Added to sequence",
      subKey: "ADDED_TO_SEQUENCE",
      key: "addedToSequence",
      method: handleAction
    }
  ];

  const operatorList = [
    {
      value: "<span class='conditionSymbol'>&equals;</span><span class='conditionLabel'>Equals</span>",
      subKey: "EQUALS",
      key: "equalCond",
      method: handleAction
    },
    {
      value: "<span class='conditionSymbol'>&ne;</span><span class='conditionLabel'>Not equals</span>",
      subKey: "NOT_EQUALS",
      key: "notEqualCond",
      method: handleAction
    }
  ];

  const fieldnameObject = {
    ACTIVE_IN_SEQUENCE: "Active in sequence",
    COMPLETED_IN_SEQUENCE: "Completed in sequence",
    ADDED_TO_SEQUENCE: "Added to sequence"
  };

  useEffect(() => {
    if (errMsg) {
      let tempData = { ...contactStoreData.contactFilterObject };
      tempData.sequences = [
        {
          fieldName: "",
          sequenceId: "",
          sequenceName: ""
        }
      ];
      contactStoreData.setContactFilterObject(tempData);
    }
  }, [errMsg]);

  return (
    <div className="contactDateFilter">
      <DropdownButton
        label={label}
        count={data?.filter(item => item?.fieldName)?.length || 0}
        keyValue={keyValue}
        toggleDropdown={toggleDropdown}
        callback={setActiveFilter}
      />
      {toggleDropdown && (
        <div className="dropdownSearchBox">
          <span className="horizontalBorderLine" />
          {(data.length && (
            <div className="sequenceFilterCard">
              {data.map((item, index) => {
                const {
                  fieldName = "",
                  sequenceId = "",
                  sequenceName = "",
                  operator = "EQUALS",
                  isMultiple = false
                } = item || {};

                const isLastItem = index === data.length - 1;
                return (
                  <div
                    className="sequenceFilter"
                    key={`sequenceFilter${index}`}
                  >
                    <div className="fieldnameDropdown">
                      {!isMultiple && (
                        <>
                          <SingleDropdown
                            isDropdownAllowed={true}
                            options={optionList}
                            defaultValue={fieldnameObject?.[fieldName] || ""}
                            label="Select"
                            referenceId="fieldName"
                            parentIndex={index}
                            hasCustomFieldValue={true}
                            showDropdown={
                              activeDropdownIndex === `fieldName-${index}`
                            }
                            setActiveDropdownIndex={setActiveDropdownIndex}
                          />

                          <i
                            className="material-icons-outlined deleteIcon"
                            onClick={() => removeItem(index)}
                          >
                            delete
                          </i>
                        </>
                      )}
                    </div>
                    {fieldName && (
                      <div className="fieldOperatorValueContainer">
                        <div className="fieldOperatorValueContainerInner">
                          <div
                            className={`fieldOperatorValue ${
                              !fieldName ? "disableInput" : ""
                            }`}
                          >
                            <SingleDropdown
                              isDropdownAllowed={true}
                              defaultValue={
                                conditionsOperatorObject?.[operator] || ""
                              }
                              showDropdown={
                                activeDropdownIndex === `operator-${index}`
                              }
                              setActiveDropdownIndex={setActiveDropdownIndex}
                              parentIndex={index}
                              referenceId="operator"
                              options={operatorList}
                            />
                            <div className="fieldNameSequenceDropdown">
                              <SingleDropdown
                                isDropdownAllowed={true}
                                className={"selectSequenceLabel"}
                                options={sequenceList}
                                defaultValue={
                                  (sequenceId && sequenceName) || ""
                                }
                                sequenceId={sequenceId}
                                label="Select"
                                referenceId="sequenceName"
                                parentIndex={index}
                                hasCustomFieldValue={true}
                                showDropdown={
                                  activeDropdownIndex ===
                                  `sequenceName-${index}`
                                }
                                activeDropdownIndex={activeDropdownIndex}
                                setActiveDropdownIndex={setActiveDropdownIndex}
                                handleSequenceAction={handleSequenceAction}
                                handleScrollEnd={handleScrollEnd}
                                isCustomDropdown={true}
                                sequenceLoader={sequenceLoader}
                                animationClass="customDropDownFadeIn"
                                search={true}
                                filterFn={filterFn}
                                isPositionTop={true}
                              />
                            </div>
                          </div>
                          <div className="deleteIconContainer">
                            <i
                              className="material-icons-outlined deleteIcon"
                              onClick={() => removeSelectedSeqItem(index)}
                            >
                              delete
                            </i>
                          </div>
                        </div>
                        {isLastItem && (
                          <div className="iconContainerWrapper">
                            <div
                              className="addIconContainer"
                              onClick={() => addMultipleSequences(fieldName)}
                            >
                              <i className="material-icons-outlined addIcon">
                                add
                              </i>
                              <span>Select Sequence</span>
                            </div>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )) ||
            ""}
          <ActionButton resetCbk={resetItem} addCbk={addItem} isReset={false} />
          {errMsg === keyValue && (
            <span className="errMessage">Please select a value</span>
          )}
        </div>
      )}
    </div>
  );
};

export default ContactSequenceFilter;
